<template>
    <page-loader v-if="loadingStatus=='loading'" />
    <div v-else class="contain-section">
        <div class="row">
            <div class="col-sm-12">
                <div class="map-wrap">
                    <div class="col-sm-12 mb-4">
                        <div class="card-section">
                            <h4 class="fs-3 text-black text-start fw-bolder mb-3">
                                Fatherline Migration Map
                            </h4>
                            <p class="text-start mb-1">
                                You're viewing your migration map which shows
                                the journey your ancestors may have taken for
                                you to get where you are today. Click on
                                "Coverage Map" below to see the regions where
                                people with your haplogroup are living today.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="row">
                            <!-- <div class="col-sm-12">
                                                    <ul class="list-of-action f-choose">
                                                        <li><a href="#">Root</a></li>
                                                        <li><a href="#">L3</a></li>
                                                        <li><a href="#" class="active">N</a></li>
                                                        <li><a href="#">R</a></li>
                                                        <li><a href="#">T</a></li>
                                                        <li><a href="#">T2</a></li>
                                                    </ul>
                                                </div> -->
                            <div class="col-sm-12">
                                <MigrationMap :result="fatherlineStore.result" type="ydna" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm-12 mt-4">
                                            <div class="card-section">
                                                <h4
                                                    class="fs-3 text-black text-start fw-bolder mb-3"
                                                >
                                                    F
                                                </h4>
                                                <p class="text-start mb-2">
                                                    The N super-haplogroup has been characterized as
                                                    pan-Eurasian. Haplogroup N is one of the two
                                                    major trunks emerging from the original African
                                                    root, and dates to approximately 65,000 years
                                                    ago. Interestingly, several sub-haplogroups of
                                                    the N cluster, haplogroup N1, and derivative
                                                    lineages, have been detected in the Near East,
                                                    suggesting either early divergence near the root
                                                    of haplogroup N or subsequent migrations back
                                                    towards Western Eurasia, following the original
                                                    dispersal into east Eurasia.
                                                </p>

                                                <p class="text-start mb-2">
                                                    Future work will further document the historical
                                                    distribution of this root haplogroup and closely
                                                    related haplogroups within the N cluster.
                                                </p>
                                                <p class="text-start mb-2">
                                                    Your ancient ancestors probably led typical
                                                    hunter-gatherer lives. They would have explored
                                                    the environment they settled in, living off the
                                                    wild berries, fruits, roots, and vegetation they
                                                    could find, supplementing this with wild game,
                                                    hunting large animals such as mammoths and wild
                                                    horses, most likely using stone blades and
                                                    spears. They would stalk their prey, and upon
                                                    reaching throwing distance, hurl their spears,
                                                    aiming to severely injure. The final kill would
                                                    be made as the animal weakened. As they became
                                                    more settled in their environment, your
                                                    ancestors adopted new methods of farming and
                                                    animal husbandry in order to support the
                                                    individuals and their families in their
                                                    community.
                                                </p>
                                            </div>
                                        </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "../../../styles/pages/ancentry/recent-ancetry.scss";
import MigrationMap from "@/components/ancestry/MigrationMap.vue";
import { useFatherlineStore } from "@/store/parentalStore";
import { ref } from "vue";
const loadingStatus = ref("loading");
const fatherlineStore = ref({});
export default {
    name: "AncestrySection",
    // Component logic
    data() {
        fatherlineStore.value = useFatherlineStore()
        loadingStatus.value = "loaded";
        return {fatherlineStore , loadingStatus };
    },
    components: {
        MigrationMap
    },
};
</script>
